import React from 'react';
import {
  Alert,
  AlertDescription,
  AlertIcon,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
} from '@chakra-ui/react';
import {useDisconnectIntegration} from '../../hooks/api/integrations';
import {useIntegrationStaticInfo} from './IntegrationDetailsContext';
import {CrmIntegrationType} from '../../shared/integrations/crm';

export function DisconnectIntegrationModal({
  isOpen,
  onClose,
  integrationType,
  infoMessage,
}: {
  isOpen: boolean;
  onClose: () => void;
  integrationType: CrmIntegrationType;
  infoMessage?: string;
}) {
  const integrationInfo = useIntegrationStaticInfo();
  const disconnectIntegration = useDisconnectIntegration();
  const toast = useToast();

  return (
    <Modal isCentered={true} isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Disconnect {integrationInfo.label}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          Are you sure you want to disconnect this integration?
          {infoMessage && (
            <Alert status="info" mt={4} alignItems="start">
              <AlertIcon />
              <AlertDescription>{infoMessage}</AlertDescription>
            </Alert>
          )}
        </ModalBody>
        <ModalFooter gap="4">
          <Button isLoading={disconnectIntegration.isPending} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="red"
            isLoading={disconnectIntegration.isPending}
            onClick={() => {
              disconnectIntegration.mutate(integrationType, {
                onSuccess: () => {
                  toast({
                    title: 'The integration has been disconnected.',
                    status: 'success',
                    isClosable: true,
                    duration: 2_000,
                  });
                  onClose();
                },
              });
            }}
          >
            Disconnect
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
